/**
 * @generated SignedSource<<89ef06f23aa65cfaa9b7cc4dd854bc62>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedShopByModuleItemVariant_trendingCreator$data = {
  readonly category: string | null;
  readonly creator: {
    readonly displayName: string | null;
  } | null;
  readonly firstItemPhotoWebPath: string | null;
  readonly trendingVerticalLinkData: {
    readonly path: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"SeoLink_linkData">;
  };
  readonly " $fragmentType": "HpSharedShopByModuleItemVariant_trendingCreator";
};
export type HpSharedShopByModuleItemVariant_trendingCreator$key = {
  readonly " $data"?: HpSharedShopByModuleItemVariant_trendingCreator$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedShopByModuleItemVariant_trendingCreator">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedShopByModuleItemVariant_trendingCreator",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "category",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LinkData",
      "kind": "LinkedField",
      "name": "trendingVerticalLinkData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "path",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SeoLink_linkData"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Creator",
      "kind": "LinkedField",
      "name": "creator",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "size",
          "value": "master"
        }
      ],
      "kind": "ScalarField",
      "name": "firstItemPhotoWebPath",
      "storageKey": "firstItemPhotoWebPath(size:\"master\")"
    }
  ],
  "type": "TrendingCreator",
  "abstractKey": null
};

(node as any).hash = "b30bcaabd5c9779a0abfdd3b29c53737";

export default node;
